// @flow
import AppPollsNA from './AppPollsNA';

export default AppPollsNA;
